export default __webpack_public_path__ + "static/media/PhoneAppOne.6ac7b843.png";